window.addEventListener("load", (event) => {
    const translations = {
        'English': "Subscribe",
        'Deutsch': "Abonnieren",
        'français': "S'abonner",
        'Italiano': "Iscriviti",
        'Español': "Suscríbete",
        '繁體中文': "訂閱"
    };

    const translationsGermanExtra = {
        'Thanks for subscribing!': "Vielen Dank fürs abonnieren!",
        'Check your email for a confirmation message.': 'Die Bestätigung haben Sie per Mail erhalten.',
    };
    const translationsPlaceholderName = {
        'English': "Name",
        'Deutsch': "Name",
        'français': "Nom",
        'Italiano': "Nome",
        'Español': "Nombre",
        '繁體中文': "姓名"
    }
    const translationsPlaceholderEmail = {
        'English': "Enter your email",
        'Deutsch': "Email Adresse eingeben",
        'français': "Entrez votre email",
        'Italiano': "Inserisci la tua email",
        'Español': "Ingresa tu email",
        '繁體中文': "輸入您的電子郵件"
    }

    const klaviyoFormSearch = setInterval(() => {
        const klaviyoFormButton = document.querySelector(".footer .block__item-klavio .needsclick[type='button']");
        if (klaviyoFormButton) {
            clearInterval(klaviyoFormSearch);
            if (translations.hasOwnProperty(currentMarket)) {
                const overlayDiv = document.createElement("div");
                overlayDiv.className = "klaviyo-button-overlay";
                overlayDiv.textContent = translations[currentMarket];
                klaviyoFormButton.parentNode.insertBefore(overlayDiv, klaviyoFormButton);

                const klaviyoFormPlaceholder = document.querySelector(".footer .block__item-klavio .needsclick[autocomplete='email']");
                if (klaviyoFormPlaceholder) {
                    klaviyoFormPlaceholder.placeholder = translationsPlaceholderEmail[currentMarket];
                }
                const klaviyoFormNamePlaceholder = document.querySelector(".footer .block__item-klavio .needsclick[aria-label='Name']");
                if (klaviyoFormNamePlaceholder) {
                    klaviyoFormNamePlaceholder.placeholder = translationsPlaceholderName[currentMarket];
                }
            }

            const observer = new MutationObserver((mutations) => {
                if (translations.hasOwnProperty(currentMarket)) {
                    const overlayDiv = document.querySelector(".klaviyo-button-overlay");
                    if (overlayDiv) {
                        overlayDiv.textContent = translations[currentMarket];
                    }

                    const klaviyoFormPlaceholder = document.querySelector(".footer .block__item-klavio .needsclick[autocomplete='email']");
                    if (klaviyoFormPlaceholder) {
                        klaviyoFormPlaceholder.placeholder = translationsPlaceholderEmail[currentMarket];
                    }
                    const klaviyoFormNamePlaceholder = document.querySelector(".footer .block__item-klavio .needsclick[aria-label='Name']");
                    if (klaviyoFormNamePlaceholder) {
                        klaviyoFormNamePlaceholder.placeholder = translationsPlaceholderName[currentMarket];
                    }
                }
            });

            const config = { childList: true, subtree: false, characterData: false };

            observer.observe(klaviyoFormButton, config);

            if (currentMarket === 'Deutsch') {
                klaviyoFormButton.addEventListener('click', () => {
                    const checkElementsInterval = setInterval(() => {
                        const klaviyoFormThankText = document.querySelector("#rich-text-108443806 span");
                        const klaviyoFormCTAText = document.querySelector("#rich-text-108443807 span");
                        if (klaviyoFormThankText && klaviyoFormCTAText) {
                            clearInterval(checkElementsInterval);
                            klaviyoFormThankText.textContent = translationsGermanExtra['Thanks for subscribing!'];
                            klaviyoFormCTAText.textContent = translationsGermanExtra['Check your email for a confirmation message.'];
                        }
                    }, 200);
                });
            }
        }
    }, 1000);
});

